import fileManagerInit from '../theme/file-manager/file-manager';

const { docReady } = window.phoenix.utils;

docReady(fileManagerInit);
